import React from 'react';
import '../../styles/services.css';
import { motion } from 'framer-motion';

const UiUxDesign = () => (
  <motion.div className="industry-page" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }}>
    <div className="industry-content">
      <h1>UI/UX Design</h1>
      <p>Designing modern, human-centric experiences that delight users and drive engagement.</p>
      <ul className="bullet-points">
        <li>🎨 Visual storytelling</li>
        <li>🔍 User research & prototyping</li>
        <li>🧠 Information architecture</li>
        <li>📱 Mobile-first responsive UI</li>
      </ul>
    </div>
  </motion.div>
);

export default UiUxDesign;
